// DS: i7.19
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const EditorFontColor: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        style={props.style}
      >
        <path d="M16.346 11.31c-.98 1.18-1.667 2.323-2.06 3.43H9.349l-1.083 2.863a.126.126 0 01-.118.081h-2.97a.126.126 0 01-.118-.175L10.7 3.945a.253.253 0 01.233-.155h2.099c.101 0 .193.06.233.155l3.082 7.365zm-4.45-3.478l-1.623 4.318h3.266l-1.643-4.318zm3.262 9.125c0 1.764 1.446 3.254 3.158 3.254 1.711 0 3.158-1.49 3.158-3.254 0-1.669-.898-3.464-2.693-5.385a.632.632 0 00-.922 0c-1.8 1.92-2.701 3.715-2.701 5.385z"></path>
      </svg>
    </IconWrap>
  );
};
EditorFontColor.displayName = 'EditorFontColor';

export default EditorFontColor;
